import React from 'react'

const Oath = ({
    oathRef,
    oath1Ref,
    oath2Ref,
    oath3Ref,
    oath4Ref,
    oath5Ref,
    oath6Ref
}) => {
    return (
        <div className="bg-[#FFFFFF] text-[#2B292A] h-[100vh] flex flex-col justify-center items-center"
            ref={oathRef}
        >
            <div
                ref={oath1Ref}
                className="px-[4vw] py-[2vh] bg-[#FFFFFF] rounded text-[3vh] hover:text-[#FFFFFF] hover:bg-[#E65445] shadow-md">In brightest day</div>
            <div className="h-[4vh]" />
            <div
                ref={oath2Ref}
                className="px-[4vw] py-[2vh] bg-[#FFFFFF] rounded text-[3vh] hover:text-[#FFFFFF] hover:bg-[#E65445] shadow-md">In blackest night</div>
            <div className="h-[4vh]" />
            <div
                ref={oath3Ref}
                className="px-[4vw] py-[2vh] bg-[#FFFFFF] rounded text-[3vh] hover:text-[#FFFFFF] hover:bg-[#E65445] shadow-md">No bugs shall</div>
            <div className="h-[4vh]" />
            <div
                ref={oath4Ref}
                className="px-[4vw] py-[2vh] bg-[#FFFFFF] rounded text-[3vh] hover:text-[#FFFFFF] hover:bg-[#E65445] shadow-md">Escape my sight</div>
            <div className="h-[4vh]" />
            <div
                ref={oath5Ref}
                className="px-[4vw] py-[2vh] bg-[#FFFFFF] rounded text-[3vh] hover:text-[#FFFFFF] hover:bg-[#E65445] shadow-md">Beware my power</div>
            <div className="h-[4vh]" />
            <div
                ref={oath6Ref}
                className="px-[4vw] py-[2vh] bg-[#FFFFFF] rounded text-[3vh] hover:text-[#FFFFFF] hover:bg-[#E65445] shadow-md">JavaScript's light</div>
        </div>
    )
}

export default Oath